module.exports = __webpack_public_path__ + "media/images/icon_job_category2_sp-8089301efdca53a44ceb8efb68ae3c98.png";